import {ACTION_CODE} from './_actionCode';
import {StaffingService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
import { GetAllStaffingSchemaType } from '../../services/staffingService/_schema/getAllStaffing.schema';
const FUNCTION_CODE = 'GET_ALL_STAFFING';

export async function getAllStaffing(
    token: '',
    params: ''
) {
    try {
        LoggerService.logInfo('Action - getAllStaffing - Start');

        const result = await StaffingService.getAllStaffing(token, params);

        const {data} = result;

        LoggerService.logInfo('Action - getAllStaffing - End - Success');

        return ResultModel.newSuccessResultTyped<GetAllStaffingSchemaType>(data);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllStaffing - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation des staffings',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
